import { render } from "./NumberOfPeople.vue?vue&type=template&id=636c16dc&scoped=true"
import script from "./NumberOfPeople.vue?vue&type=script&lang=js"
export * from "./NumberOfPeople.vue?vue&type=script&lang=js"

import "./NumberOfPeople.vue?vue&type=style&index=0&id=636c16dc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/nush-bookings/nush-bookings/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636c16dc"]])

export default __exports__